import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UsersInfo } from '../interfaces/users-info';
import { HierarchyScopeService } from './hierarchy-scope.service';
import { StorageKey, StorageService } from './common/storage.service';

@Injectable({
  providedIn: 'root'
})
export class UserInfoService {
  uinfo: UsersInfo;
  constructor(
    private _router: Router,
    private _storageService: StorageService,
    private hierarchyScopeService: HierarchyScopeService,
  ) {
    this.uinfo = {
      loginUserInfo: null,
      authToken: null,
      loginFlag: false
    }
  }

  setUserInfo(usr: any) {
    this.uinfo.loginUserInfo = usr;
  }

  setToken(token: any = null) {
    this.uinfo.authToken = token;
    if (!!token) {
      sessionStorage.setItem('currentUser', JSON.stringify({ token: token, userInfo: this.uinfo.loginUserInfo }));
    }
  }

  setLoginFlag(flag: boolean = false) {
    this.uinfo.loginFlag = flag;
  }

  getUserInfo() {
    let currentSession = localStorage.getItem('currentUser');
    if (currentSession) {
      {
        let data = JSON.parse(currentSession);
        return data.userInfo ? data.userInfo : data;

      }
    } else {
      return null;
    }
  }

  getAccessToken() {
    var token = this._storageService.getValue(StorageKey.authToken);
    return token ? token : null;
    // return this.uinfo.authToken;
  }

  getLoginFlag() {
    return !!localStorage.getItem('currentUser');
  }
  // getLoginFlag() {
  //   if (!this.uinfo.loginFlag) {
  //     let currentSession = localStorage.getItem('currentUser');
  //     if (currentSession) {
  //       return true;
  //     } else {
  //       return false;
  //     }
  //   } else {
  //     return this.uinfo.loginFlag;
  //   }
  // }

  logout() {
    this.hierarchyScopeService.reset();
    this.setLoginFlag(false);
    this.setToken();
    this._storageService.removeValue(StorageKey.authToken);
    this._storageService.removeValue(StorageKey.currentUser);
    this._storageService.removeValue(StorageKey.companyData);
    this._storageService.removeValue(StorageKey.menuRights);

    //vcard users

    if (localStorage.getItem('vcardToken')) {
      localStorage.removeItem('vcardUser');
      localStorage.removeItem('vcardToken')
      sessionStorage.removeItem('vcardUser');
    }

    sessionStorage.removeItem('currentUser');
    this._router.navigate(['/']);
  }
}
